import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QaiButtonComponent, QaiDialogComponent } from '@qai/ui';
import { AuthorReactiveFormService } from '../../../services/author-reactive-form.service';
import { SimulationConstants } from 'src/app/utils/constants/self-serve/simulation.constants';
import { take } from 'rxjs';

@Component({
  selector: 'save-as-product-default-modal',
  standalone: true,
  templateUrl: './save-as-product-default-modal.component.html',
  styleUrls: ['./save-as-product-default-modal.component.scss'],
  imports: [CommonModule, QaiDialogComponent, QaiButtonComponent],
})
export class SaveAsProductDefaultModalComponent implements OnChanges {
  @ViewChild('dialog') dialogRef: QaiDialogComponent | undefined;

  @Input() open: boolean = false;
  @Input() networkRequestInProgress: boolean = false;
  @Input() moduleUuid: string = '';
  @Input() keywordTitle: string = '';

  @Output() openChange = new EventEmitter<boolean>();
  @Output() confirm = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  moduleName: string = '';
  private callUuid: string = '';

  constructor(
    private authorReactiveFormService: AuthorReactiveFormService,
    private route: ActivatedRoute
  ) {
    this.callUuid = this.route.snapshot.paramMap.get('uuid') || '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      const isOpenNow = changes['open']?.currentValue;

      if (isOpenNow) {
        this.loadModuleName();
        this.dialogRef?.showModal();
      } else {
        this.dialogRef?.close();
      }
    }
  }

  private loadModuleName(): void {
    if (!this.callUuid) {
      this.moduleName = '';
      return;
    }

    this.authorReactiveFormService
      .getForm(this.callUuid)
      .pipe(take(1))
      .subscribe((form) => {
        const generalSection = form.get(
          SimulationConstants.GENERAL_SECTION
        );
        this.moduleName = generalSection?.get('moduleName')?.value || '';
      });
  }

  handleConfirm(): void {
    if (this.networkRequestInProgress) {
      return;
    }

    this.confirm.emit();
  }

  handleClose(): void {
    this.setClosedState();
  }

  handleCloseButtonClick(): void {
    this.setClosedState();
  }

  private setClosedState(): void {
    if (this.open) {
      this.closeModal.emit();
      this.open = false;
      this.dialogRef?.close();
      this.openChange.emit(false);
    }
  }
}
